export type TimeSuggestionOption = {
  id: "tomorrow" | "next-week";
  label: string;
  value: string;
};

const suggestionFormatter = new Intl.DateTimeFormat("nb-NO", {
  weekday: "short",
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit"
});

export function toLocalDateTimeValue(date: Date): string {
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

export function fromLocalDateTimeValue(value: string): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function buildTimeSuggestionOptions(
  planStartsAt: string,
  now: Date = new Date()
): TimeSuggestionOption[] {
  const planStart = new Date(planStartsAt);
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(planStart.getHours(), planStart.getMinutes(), 0, 0);

  // If the plan is already tomorrow at that exact time, keep the one-tap
  // option useful by nudging it one hour while staying on the same day.
  if (Math.abs(tomorrow.getTime() - planStart.getTime()) < 5 * 60_000) {
    const day = tomorrow.getDate();
    tomorrow.setHours(tomorrow.getHours() + 1);
    if (tomorrow.getDate() !== day) tomorrow.setHours(tomorrow.getHours() - 2);
  }

  const nextWeek = new Date(planStart);
  nextWeek.setDate(nextWeek.getDate() + 7);

  return [
    { id: "tomorrow", label: "I morgen", value: toLocalDateTimeValue(tomorrow) },
    { id: "next-week", label: "Neste uke", value: toLocalDateTimeValue(nextWeek) }
  ];
}

export function formatSuggestedTime(value: string): string {
  return suggestionFormatter.format(new Date(value));
}

export function validateSuggestedTime(
  value: string,
  planStartsAt: string,
  now: Date = new Date()
): string | null {
  const proposed = fromLocalDateTimeValue(value);
  if (!proposed) return "Velg en gyldig dato og tid.";
  if (proposed.getTime() < now.getTime() + 15 * 60_000) {
    return "Velg et tidspunkt som er minst 15 minutter frem i tid.";
  }
  if (proposed.getTime() > now.getTime() + 366 * 24 * 60 * 60_000) {
    return "Velg et tidspunkt innen ett år.";
  }
  if (Math.abs(proposed.getTime() - new Date(planStartsAt).getTime()) < 5 * 60_000) {
    return "Velg et annet tidspunkt enn det som allerede er satt.";
  }
  return null;
}
